module.exports = __webpack_public_path__ + "img/Alternatives-Alternative assessment.b9dee11e.svg";